// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.similarity-weights {
  margin-bottom: 1.5rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.weights-header {
  padding: 0.8rem 1rem;
  background: #f5f5f5;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s;
}

.weights-header:hover {
  background: #eee;
}

.weights-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.weights-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.weights-summary {
  font-size: 0.8rem;
  color: #666;
  background: #e9ecef;
  padding: 0.2rem 0.6rem;
  border-radius: 10px;
}

.expand-icon {
  font-size: 0.7rem;
  color: #666;
}

.weights-content {
  padding: 1rem;
  border-top: 1px solid #ddd;
}

.weights-description {
  margin: 0 0 1rem 0;
  color: #666;
  font-size: 0.85rem;
}

.weights-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.weight-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0.8rem;
  background: #f8f9fa;
  border-radius: 6px;
  gap: 1rem;
}

.weight-info {
  flex: 1 1;
  min-width: 0;
}

.weight-label {
  display: block;
  font-weight: 500;
  font-size: 0.9rem;
  color: #333;
}

.weight-desc {
  display: block;
  font-size: 0.75rem;
  color: #888;
  margin-top: 2px;
}

.weight-control {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.weight-slider {
  width: 100px;
  height: 4px;
  border-radius: 2px;
  background: #ddd;
  outline: none;
  cursor: pointer;
}

.weight-slider::-webkit-slider-thumb {
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--button-color, #007bff);
  cursor: pointer;
}

.weight-slider::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--button-color, #007bff);
  cursor: pointer;
  border: none;
}

.weight-value {
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--button-color, #007bff);
  min-width: 40px;
  text-align: right;
}

.weights-footer {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total-weight {
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0.4rem 0.8rem;
  border-radius: 4px;
}

.total-weight.valid {
  background: #d4edda;
  color: #155724;
}

.total-weight.invalid {
  background: #fff3cd;
  color: #856404;
}

.weight-warning {
  font-weight: 400;
  font-size: 0.8rem;
}

.btn-reset {
  padding: 0.4rem 0.8rem;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  color: #666;
  transition: all 0.2s;
}

.btn-reset:hover {
  background: #f5f5f5;
  border-color: #bbb;
}

@media (max-width: 600px) {
  .weight-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .weight-control {
    width: 100%;
  }

  .weight-slider {
    flex: 1 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Search/SimilarityWeights.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;AACF","sourcesContent":[".similarity-weights {\n  margin-bottom: 1.5rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n  background: white;\n}\n\n.weights-header {\n  padding: 0.8rem 1rem;\n  background: #f5f5f5;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  user-select: none;\n  transition: background 0.2s;\n}\n\n.weights-header:hover {\n  background: #eee;\n}\n\n.weights-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.weights-header h4 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.weights-summary {\n  font-size: 0.8rem;\n  color: #666;\n  background: #e9ecef;\n  padding: 0.2rem 0.6rem;\n  border-radius: 10px;\n}\n\n.expand-icon {\n  font-size: 0.7rem;\n  color: #666;\n}\n\n.weights-content {\n  padding: 1rem;\n  border-top: 1px solid #ddd;\n}\n\n.weights-description {\n  margin: 0 0 1rem 0;\n  color: #666;\n  font-size: 0.85rem;\n}\n\n.weights-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.weight-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.6rem 0.8rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  gap: 1rem;\n}\n\n.weight-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.weight-label {\n  display: block;\n  font-weight: 500;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.weight-desc {\n  display: block;\n  font-size: 0.75rem;\n  color: #888;\n  margin-top: 2px;\n}\n\n.weight-control {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.weight-slider {\n  width: 100px;\n  height: 4px;\n  border-radius: 2px;\n  background: #ddd;\n  outline: none;\n  cursor: pointer;\n}\n\n.weight-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--button-color, #007bff);\n  cursor: pointer;\n}\n\n.weight-slider::-moz-range-thumb {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--button-color, #007bff);\n  cursor: pointer;\n  border: none;\n}\n\n.weight-value {\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: var(--button-color, #007bff);\n  min-width: 40px;\n  text-align: right;\n}\n\n.weights-footer {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.total-weight {\n  font-size: 0.9rem;\n  font-weight: 600;\n  padding: 0.4rem 0.8rem;\n  border-radius: 4px;\n}\n\n.total-weight.valid {\n  background: #d4edda;\n  color: #155724;\n}\n\n.total-weight.invalid {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.weight-warning {\n  font-weight: 400;\n  font-size: 0.8rem;\n}\n\n.btn-reset {\n  padding: 0.4rem 0.8rem;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  color: #666;\n  transition: all 0.2s;\n}\n\n.btn-reset:hover {\n  background: #f5f5f5;\n  border-color: #bbb;\n}\n\n@media (max-width: 600px) {\n  .weight-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .weight-control {\n    width: 100%;\n  }\n\n  .weight-slider {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
